
export const REAL_ESTATE_LISTING_TYPES = ['Satılık', 'Kiralık', 'Günlük Kiralık', 'Devren Satılık', 'Devren Kiralık'];

export const ROOM_COUNTS = ['1+0 (Stüdyo)', '1+1', '2+0', '2+1', '3+1', '4+1', '4+2', '5+1', '5+2', '6+1', '6+2', '7+1 ve üzeri'];

export const BUILDING_AGES = ['0 (Yeni)', '1', '2', '3', '4', '5-10', '11-15', '16-20', '21-25', '26-30', '31 ve üzeri'];

export const FLOOR_NUMBERS = [
    'Bodrum Kat', 'Zemin Kat', 'Giriş Katı', 'Bahçe Katı', 'Müstakil',
    '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11-20', '21 ve üzeri'
];

export const HEATING_TYPES = [
    'Yok', 'Soba', 'Doğalgaz Sobası', 'Kat Kaloriferi', 'Kombi (Doğalgaz)',
    'Merkezi (Pay Ölçer)', 'Merkezi', 'Klima', 'Fancoil', 'Güneş Enerjisi',
    'Yerden Isıtma', 'Isı Pompası', 'Jeotermal'
];

export const DEED_STATUS = ['Kat Mülkiyeti', 'Kat İrtifakı', 'Arsa Payı', 'Bilinmiyor'];

export const ZONING_STATUS = [
    'Konut', 'Ticari', 'Konut + Ticari', 'Sanayi', 'Turizm',
    'Tarımsal', 'Bağ/Bahçe', 'Zeytinlik', 'SİT Alanı'
];

export const FACADE_TYPES = ['Kuzey', 'Güney', 'Doğu', 'Batı', 'Kuzey-Doğu', 'Kuzey-Batı', 'Güney-Doğu', 'Güney-Batı'];

export const PARKING_TYPES = ['Yok', 'Açık Otopark', 'Kapalı Otopark', 'Yeraltı Otoparkı'];

export const SITE_FEATURES = ['7/24 Güvenlik', 'Yüzme Havuzu', 'Spor Salonu', 'Çocuk Oyun Alanı', 'Yeşil Alan', 'Sosyal Tesis'];

export const SUITABILITY_STATUS = ['Krediye Uygun', 'Krediye Uygun Değil', 'Belirtilmemiş'];
